<h2 i18n>Clear the cards from the table</h2>

<div class="table new-round-preparation-anim"></div>
